"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBell = void 0;

var React = __importStar(require("react"));

exports.IconBell = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "35",
    height: "40",
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M17.4876 37.8946C16.2625 37.8946 15.1368 37.4318 14.3916 36.62C14.0373 36.235 13.6185 35.5976 13.6185 34.7384L11.6813 34.7346C11.6795 35.9694 12.1542 37.1663 13.0199 38.1089C14.1246 39.3115 15.7529 40 17.4859 40C20.6901 40 23.2994 37.6385 23.3043 34.7384L21.3671 34.7346C21.3636 36.4796 19.6236 37.8946 17.4875 37.8946L17.4876 37.8946Z",
    fill: color
  }), React.createElement("path", {
    d: "M34.9063 29.2118C35.0303 27.7323 35.1786 25.4981 34.2868 23.7094L34.1316 23.533C33.8646 23.1896 33.5503 22.871 33.2171 22.5372C31.9133 21.2246 30.1281 19.4246 29.7458 14.1363C29.2273 7.11067 24.8505 0 17.4943 0C10.1381 0 5.76101 7.11114 5.24099 14.1383C4.85529 19.4246 3.07166 21.2227 1.76974 22.5372C1.43641 22.8729 1.12227 23.1916 0.855234 23.533L0.745287 23.7094C-0.146524 25.4981 -0.043542 27.7323 0.0820915 29.2118C0.115251 29.6026 0.0594037 29.9421 0.0594037 30.2076V30.8241L0.640571 31.1256C4.74011 33.6161 10.1118 34.7748 17.4505 34.7748C24.7911 34.7748 30.2238 33.6161 34.3253 31.1256L34.9291 30.8241V30.2076C34.9291 29.9421 34.8733 29.6006 34.9066 29.2118H34.9063ZM32.8906 29.0183C32.8733 29.2098 32.8593 29.3921 32.8471 29.5628C29.1053 31.6813 24.2064 32.6696 17.4945 32.6696C10.7839 32.6696 5.88361 31.6793 2.14008 29.5628C2.12786 29.3921 2.11215 29.2098 2.09644 29.0183C1.98824 27.7513 1.84339 26.0311 2.40186 24.8075C2.58511 24.5875 2.81896 24.3504 3.08776 24.0792C4.53804 22.6187 6.72827 20.409 7.17329 14.3052C7.60787 8.42885 11.0233 2.1053 17.4947 2.1053C23.9662 2.1053 27.3816 8.42885 27.8161 14.3052C28.2613 20.4107 30.4531 22.6205 31.9036 24.0811C32.1723 24.3524 32.4061 24.5895 32.5893 24.8095C33.1443 26.0273 32.9978 27.7513 32.8913 29.0183H32.8906Z",
    fill: color
  }));
});